<div>
    <dx-data-grid
        bds-grid
        id="bdsReportGrid"
        [dataSource]="gridSource"
        height="80vh"
        minHeight="200px"
        [allowColumnResizing]="true"
        [columnAutoWidth]="true"
        [showBorders]="true"
    >
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

        <dxi-column dataField="car_init" caption="Car Init"></dxi-column>
        <dxi-column dataField="car_no" caption="Car No."></dxi-column>
        <dxi-column
            dataField="ship_date_time"
            caption="Ship Date"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="car_status" caption="Car Status"></dxi-column>
        <dxi-column dataField="trip_status" caption="Trip Status"></dxi-column>
        <dxi-column dataField="car_condition" caption="Condition"></dxi-column>
        <dxi-column dataField="cust_no" caption="Cust No."></dxi-column>
        <dxi-column dataField="cust_name" caption="Customer"></dxi-column>
        <dxi-column dataField="fleet_id" caption="Fleet"></dxi-column>
        <dxi-column dataField="business_group" caption="Business Group"></dxi-column>
        <dxi-column dataField="route_code" caption="Route"></dxi-column>
        <dxi-column dataField="route_dscr" caption="Route Dscr"></dxi-column>
        <dxi-column dataField="trip_no" caption="Trip No."></dxi-column>
        <dxi-column dataField="orig_city" caption="Origin"></dxi-column>
        <dxi-column dataField="orig_state" caption="St"></dxi-column>
        <dxi-column dataField="dest_city" caption="Destination"></dxi-column>
        <dxi-column dataField="dest_state" caption="St"></dxi-column>
        <dxi-column dataField="release_city" caption="Release City"></dxi-column>
        <dxi-column dataField="release_state" caption="St"></dxi-column>
        <dxi-column dataField="return_city" caption="Return City"></dxi-column>
        <dxi-column dataField="return_state" caption="St"></dxi-column>
        <dxi-column dataField="car_type" caption="Car Type"></dxi-column>
        <dxi-column dataField="comm_code" caption="Comm Code"></dxi-column>
        <dxi-column
            dataField="clm_date_time"
            caption="CLM Date"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="sight_code" caption="Code"></dxi-column>
        <dxi-column dataField="loc_city" caption="Location"></dxi-column>
        <dxi-column dataField="loc_state" caption="St"></dxi-column>
        <dxi-column dataField="le" caption="L/E"></dxi-column>
        <dxi-column dataField="road" caption="Road"></dxi-column>
        <dxi-column
            dataField="orig_eda_eta_cust"
            caption="ETA to Cust"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column
            dataField="orig_eda_eta_origin"
            caption="ETA to Origin"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="bad_order_days" caption="BO Days"></dxi-column>
        <dxi-column
            dataField="dest_arr_date_time"
            caption="Dest Arrival"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="dest_arr_type" caption="Arr Type"></dxi-column>
        <dxi-column
            dataField="cust_dlv_date_time"
            caption="Cust Delivery"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="cust_dlv_type" caption="Dlv Type"></dxi-column>
        <dxi-column
            dataField="cust_rel_date_time"
            caption="Cust Release"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="cust_rel_type" caption="Rel Type"></dxi-column>
        <dxi-column
            dataField="trip_cls_date_time"
            caption="Trip Close"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="trip_cls_type" caption="Cls Type"></dxi-column>
        <dxi-column
            dataField="prev_trip_close_date_time"
            caption="Prev Trip Close"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column
            dataField="rqst_dlv_date_time"
            caption="Rqst Delivery"
            format="MM/dd/yy HH:mm"
            dataType="datetime"
        ></dxi-column>
        <dxi-column dataField="divert_yorn" caption="Divert"></dxi-column>
        <dxi-column dataField="shop_move" caption="Shop Move"></dxi-column>
        <dxi-column dataField="one_way_round" caption="OW/RT"></dxi-column>
        <dxi-column dataField="free_runner" caption="Free Runner"></dxi-column>
        <dxi-column dataField="freight_pmt_code" caption="Freight Pmt"></dxi-column>
        <dxi-column dataField="supplier_shipment" caption="Supplier Shpmt"></dxi-column>
        <dxi-column dataField="supplier_code" caption="Supplier Code"></dxi-column>
        <dxi-column dataField="supplier_name" caption="Supplier Name"></dxi-column>
        <dxi-column dataField="shipment_type" caption="Shpmt Type"></dxi-column>
        <dxi-column dataField="bol_no" caption="BOL No."></dxi-column>
        <dxi-column dataField="shipper_no" caption="Shipper No."></dxi-column>
        <dxi-column dataField="cust_po_no" caption="Cust PO No."></dxi-column>
        <dxi-column dataField="csr_no" caption="CSR No."></dxi-column>
        <dxi-column dataField="unit_train_id" caption="Unit Train"></dxi-column>
        <dxi-column dataField="route_road" caption="Route Road"></dxi-column>
        <dxi-column dataField="dlv_road" caption="Dlv Road"></dxi-column>
        <dxi-column dataField="hot_list_flag" caption="Hot List"></dxi-column>
        <dxi-column dataField="COMMENTS" caption="Comments"></dxi-column>
        <dxi-column dataField="extract_yorn_1" caption="Extract"></dxi-column>
        <dxi-column dataField="trip_ref1" caption="Ref 1" [visible]="false"></dxi-column>
        <dxi-column dataField="trip_ref2" caption="Ref 2" [visible]="false"></dxi-column>
        <dxi-column dataField="trip_ref3" caption="Ref 3" [visible]="false"></dxi-column>
        <dxi-column dataField="trip_ref4" caption="Ref 4" [visible]="false"></dxi-column>
        <dxi-column dataField="trip_ref5" caption="Ref 5" [visible]="false"></dxi-column>
        <dxi-column dataField="trip_ref6" caption="Ref 6" [visible]="false"></dxi-column>
        <dxo-summary>
            <dxi-total-item
                summaryType="count"
                displayFormat="Total Count: {0}"
                alignment="right"
            ></dxi-total-item>
        </dxo-summary>
    </dx-data-grid>
</div>
